import useSWR from 'swr';
import dynamic from 'next/dynamic';
import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import Loading from '@/components/Loading/Loading';
import { objectToUrlParams } from './helpers';
import { DefaultCarouselProps } from './types';

const FallBackCarousel = dynamic(() => import('./FallBackCarousel'));
const ProductCarousel = dynamic(() => import('./ProductCarousel'));

const DefaultCarousel = ({
  category,
  sectionClasses,
}: DefaultCarouselProps) => {
  const productsCarouselParams = objectToUrlParams({
    categories: category,
  });

  const { data: offers } = useSWR<SearchOffers[]>(
    `/api/search/best-seller-offers?${productsCarouselParams}`,
  );

  if (!offers) return <Loading />;
  if (offers.length > 4) return <ProductCarousel offers={offers} />;

  return <FallBackCarousel sectionClasses={sectionClasses} />;
};

export default DefaultCarousel;
